"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryTokenize = void 0;

var _common = require("./../common");

var _service = require("./../service");

class BasisTheoryTokenize extends _service.BasisTheoryService {
  tokenize(tokens, options = {}) {
    return this.client.post('/', tokens, (0, _common.createRequestConfig)(options, {
      transformRequest: _common.proxyRaw,
      transformResponse: _common.proxyRaw
    })).then(_common.dataExtractor);
  }

}

exports.BasisTheoryTokenize = BasisTheoryTokenize;